
export class ModelBase {

    constructor(dataItem?) {

        if (dataItem) {
            for (var property in dataItem) {
                if (dataItem.hasOwnProperty(property)) {
                    this[property] = dataItem[property];
                }
            }
        }
    }

    stringToDate?(propertyName: string) {
        let val = this[propertyName];
        if (val) {
            if (typeof val === "string") {
                this[propertyName] = new Date(val);
            }
        }
    }
}